interface WindowOneTrust extends Window {
  OneTrust?: { changeLanguage: (lang: string) => void };
}

export const setOneTrustLanguage = (lang: string) => {
  const windowOneTrust: WindowOneTrust = window;
  if (typeof windowOneTrust?.OneTrust?.changeLanguage === "function") {
    windowOneTrust?.OneTrust?.changeLanguage(getOneTrustLanguageCode(lang)); 
  }
};

const getOneTrustLanguageCode = (lang: string) => {
  if (!lang) return "en";

  const langCode = lang.split("-")[0];
  return langCode;
};
